import {Injectable} from '@angular/core';
import {Actions, createEffect,  ofType} from '@ngrx/effects';
import {map} from 'rxjs/operators';
import {debug} from '../../../rxjs-operators';
import {LoadCurrentSiteAction} from '../actions/current-site';
import {ChangeSiteAction, userContextActionTypes} from '../actions/user-context';

@Injectable()
export class UserContextSiteEffect {

  changeSite$ = createEffect(() => { return this.actions$.pipe(ofType(userContextActionTypes.CHANGE_SITE),
    debug('Change site action received'),
    map((action: ChangeSiteAction) =>
      new LoadCurrentSiteAction(action.payload)
    )
  )});

  constructor(private actions$: Actions) {}
}
